import React, { Fragment, useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import OtpInput from 'react-otp-input'
import { Button } from 'loyal-react'

const SendPhoneToken = ({
  isLoading,
  registeredPhone,
  sonarToken,
  campaingId,
  expiredTime,
  timeLeft,
  toSeconds,
  handleChange,
  handleValidateSonarToken,
  handleSendSonarPhoneToken,
  errors
}) => {
  const [isValid, setIsValid] = useState(false)

  const changeSonar = (value) => {
    setIsValid(value && value.toString().length === 6)
    handleChange({
      target: {
        name: 'sonarToken',
        value: `${value}`.replace(/\D/g, '')
      }
    })
  }

  const passwordContainerRef = useRef()

  useEffect(() => {
    const inputs = passwordContainerRef.current.querySelectorAll('input')
    inputs.forEach((input, index) => {
      input.setAttribute('aria-label', `${index + 1}º digito`)
    })

    document.activeElement.blur()
  }, [])

  return (
    <Fragment>
      <div className='col-12 border-color-ui-3 bg-white border radius'>
        <div className='checkout-step row px-1 py-2 border-bottom border-color-ui-3 '>
          <div className='col mr-auto'>
            <h1 className='txt-title txt-font-body txt-initial color-title mr-auto'>
              Desbloqueie a senha da central de atendimento
            </h1>
          </div>
        </div>
        <div className='col-12 border-color-ui-3'>
          <p className='my-2'>Enviamos por SMS um código para o número abaixo.</p>
          <h2
            className='h3 txt-title-3 col-12 col-md-6 color-brand-1 txt-font-body mb-1 border border-color-brand-1 p-2'
            style={{ color: '#ec7000 !important;' }}
          >
            {registeredPhone}
          </h2>
          <a
            href={process.env.REACT_APP_ONBOARDING_ENDPOINT + campaingId}
            className='color-brand-2 txt-underline'
          >
            Opps! Este não é o meu telefone
          </a>
          <div className='row px-0 pb-2 pt-half border-bottom border-color-ui-3' />
          <div className='row'>
            <div className='col-12 col-md-6 password-numeric-box mt-3'>
              <p className='mb-2'>Agora digite o código de verificação nos campos abaixo.</p>
              <div
                ref={passwordContainerRef}
                aria-label='Campos de senha numérica'
              >
                <OtpInput
                  name='sonarToken'
                  id='sonarToken'
                  value={sonarToken}
                  onChange={changeSonar}
                  shouldAutoFocus
                  numInputs={6}
                  tabIndex='0'
                  focusStyle={{ outline: 0 }}
                  valid={errors['SonarValidToken'] ? false : undefined}
                  data-error={errors['SonarValidToken'] && errors['SonarValidToken']}
                />
              </div>
            </div>
          </div>
          <div className='col-12 col-md-6 mt-2'>
            <div className='col-12 px-0 pb-2'>
              <Button
                id={'btn-password'}
                name={'btn-password'}
                className='btn btn-sm btn-featured border border-color-ui-3 mr-1'
                type='button'
                text='Confirmar e continuar'
                disabled={!isValid || sonarToken === ''}
                onClick={handleValidateSonarToken}
                loading={isLoading}
              />
            </div>
            <div className='col-12 px-0 pb-2'>
              <Button
                id={'btn-resend'}
                name={'btn-resend'}
                className='btn-heigth-pros btn-especific btn-reenviar mr-1 height50'
                type='button'
                text={expiredTime ? 'Reenviar' : `Reenviar em ${toSeconds(timeLeft)}`}
                onClick={handleSendSonarPhoneToken}
                loading={isLoading}
                disabled={!expiredTime}
              />
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  )
}

SendPhoneToken.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  registeredPhone: PropTypes.string.isRequired,
  sonarToken: PropTypes.string.isRequired,
  campaingId: PropTypes.string.isRequired,
  expiredTime: PropTypes.bool,
  timeLeft: PropTypes.number,
  toSeconds: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleValidateSonarToken: PropTypes.func.isRequired,
  handleSendSonarPhoneToken: PropTypes.func.isRequired,
  errors: PropTypes.object
}

export default SendPhoneToken



// WEBPACK FOOTER //
// ./src/Participant/UraPassword/UnlockUraPassword/SendPhoneToken/SendPhoneToken.js